export default "<button class=\"player__panel-button j-toggle-video\" title=\"Play/Pause\">\n  <span class=\"icon-container\"></span>\n</button>\n"